import http from './http'

export default {
    contacts() {
       return http.get('skypark/contacts') 
    },

    addComment(contacto, contenido) {
        return http.post(`skypark/contacts/${contacto}/comentarios`, {
            contenido
        })
    },
}